import { connect } from "react-redux";
import VendorList from "./vendorList";
import { bindActionCreators } from "redux";
import { getVendorRequestList, getVendorRequestListSearch } from "services/redux/sales/vendorPortal/action";

const mapStateToProps = (state) => ({
  postSalesList: state.vendorPortalReducer.vendorRequestList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getVendorRequestList,
      getVendorRequestListSearch,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(VendorList);
